import React, { useEffect, useState } from 'react';
import HotEvent from './HotEvent';
import Keyword from './Keyword';
import { canRequest } from '../utils';
import { getStudioKeywordEvent } from '@op/services';
import { getRetryStartTime } from '@home/pages/studio/opinions/KeywordHotEvent/utils';
import {
  IHotEventData,
  IKeyword,
  IKeywordEventFilter,
  IKeywordEventResponse,
} from './_type';

export default function KeywordHotEvent({ filter }: { filter: IKeywordEventFilter; }) {
  const [value, setValue] = useState('total');
  const [keyword, setKeyword] = useState<IKeyword[]>([]);
  const [hotEvent, setHotEvent] = useState<IHotEventData>({
    hot_events: [],
    hot_event_has_data_time: {},
  });
  const [keywordLoading, setKeywordLoading] = useState(false);
  const [hotEventLoading, setHotEventLoading] = useState(false);

  async function requestKeywordData() {
    setKeywordLoading(true);
    try {
      const params: IKeywordEventFilter = {
        ...filter,
        channel_type: value,
        keyword_top_n: 10,
        top_n: 4,
      };
      const data = await getStudioKeywordEvent(params);
      // API 返回的数据结构包含 keywords 字段
      // @ts-ignore - API 返回类型为 overviewOriginType，但实际包含 IKeywordEventResponse 的字段
      const { keywords } = data as IKeywordEventResponse;
      setKeyword(keywords || []);
    } catch (e) {
      console.error('Failed to load keyword data:', e);
    } finally {
      setKeywordLoading(false);
    }
  }

  async function requestHotEventData(otherParams: IKeywordEventFilter = {}) {
    setHotEventLoading(true);
    try {
      const params: IKeywordEventFilter = {
        ...filter,
        channel_type: value,
        keyword_top_n: 10,
        top_n: 4,
        only_hot_event: true,
        ...otherParams,
      };

      params.start_time = getRetryStartTime(params?.end_time as string);
      const data = await getStudioKeywordEvent(params);
      // API 返回的数据结构包含 hot_events 和 hot_event_has_data_time 字段
      const { hot_events: hotEvents, hot_event_has_data_time: hotEventHasDataTime } =
        // @ts-ignore - API 返回类型为 overviewOriginType，但实际包含 IKeywordEventResponse 的字段
        (data as IKeywordEventResponse);
      setHotEvent({
        hot_events: hotEvents,
        hot_event_has_data_time: hotEventHasDataTime,
      });
    } catch (e) {
      console.error(e);
    } finally {
      setHotEventLoading(false);
    }
  }

  useEffect(() => {
    if (canRequest(filter)) {
      requestKeywordData();
      requestHotEventData();
    }
  }, [filter, value]);

  return (
    <div className="dbh-studio-keyword-hotevent">
      <Keyword
        value={value}
        filter={filter}
        loading={keywordLoading}
        feedsKeyword={keyword}
      />
      <HotEvent
        data={hotEvent}
        filter={filter}
        loading={hotEventLoading}
        value={value}
        setValue={setValue}
      />
    </div>
  );
}
